<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div>
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <org-unit-proforma-invoices
                    v-if="billing.is_billable"
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                    :paymentTermsDays="billing.payment_terms_days"
                />
            </template>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitProformaInvoices from '~/components/settings/billing/OrgUnitProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';
import { ref, onMounted, watch } from 'vue';
import { orgUnitBillingClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const billing = ref(null);
const $toasted = useToasted();

const getBillingDetails = async () => {
    try {
        const response = await orgUnitBillingClient.getBillingDetails(props.teamId, props.orgUnitId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
        $toasted.error('Failed to load billing details. Please try again.');
    }
};

onMounted(() => {
    getBillingDetails();
});

watch(
    () => props.orgUnitId,
    () => {
        getBillingDetails();
    }
);
</script>
